module.exports = __webpack_public_path__ + "fonts/VetoSansCond-Medium.bf861315.woff2";